import TicketList from './container';

export default TicketList;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/EventTickets/index.js